(function() { window.GUID_867b80f6_4221_4822_9f8f_ab5ebb1b67db = { getGuid: function() { return "867b80f6-4221-4822-9f8f-ab5ebb1b67db"; } }; })();
////namespace CS.App.Views._Shared.WallSections {
////    CS.Controls.Accordion.Events.Ready({
////        selector: "body",
////        childSelector: ".accordion-operatorplayers",
////        callback: function (control, e) {
////            control.$Container.offon("click.player-box", ".operator-player-row", function (e) {
////                const $target = $(e.target)
////                alert('test');
////            });
////        }
////    });
////}

//# sourceMappingURL=operator-team-row.js.map
